module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix",
    attrs: {
      "id": "stockQuery"
    }
  }, [_c('el-col', [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "inline": true,
      "model": _vm.form,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择仓库类型"
    },
    model: {
      value: (_vm.form.warehouseType),
      callback: function($$v) {
        _vm.$set(_vm.form, "warehouseType", $$v)
      },
      expression: "form.warehouseType"
    }
  }, _vm._l((_vm.wareArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "门店",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.belongDeptId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "belongDeptId", $$v)
      },
      expression: "searchForm.belongDeptId"
    }
  }, _vm._l((_vm.shopDataList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.attribute1,
        "value": item.deptId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "品牌"
    },
    on: {
      "change": _vm.choseBrand
    },
    model: {
      value: (_vm.form.brandId),
      callback: function($$v) {
        _vm.$set(_vm.form, "brandId", $$v)
      },
      expression: "form.brandId"
    }
  }, _vm._l((_vm.brandList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "品类"
    },
    on: {
      "change": _vm.choseCategory
    },
    model: {
      value: (_vm.form.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.form, "categoryId", $$v)
      },
      expression: "form.categoryId"
    }
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "型号"
    },
    on: {
      "change": _vm.choseModel
    },
    model: {
      value: (_vm.form.modelId),
      callback: function($$v) {
        _vm.$set(_vm.form, "modelId", $$v)
      },
      expression: "form.modelId"
    }
  }, _vm._l((_vm.modelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "物料"
    },
    model: {
      value: (_vm.searchForm.materialCoding),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialCoding", $$v)
      },
      expression: "searchForm.materialCoding"
    }
  }, _vm._l((_vm.materialFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.materialName,
        "value": item.materialCoding
      }
    }, [_vm._v(_vm._s(item.materialName))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "物料编码"
    },
    model: {
      value: (_vm.searchForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.materialCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "物料名称"
    },
    model: {
      value: (_vm.searchForm.materialName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.materialName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "序列号"
    },
    model: {
      value: (_vm.searchForm.code),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "margin-bottom": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitSearch('searchForm')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "60px",
      "color": "#169BD5"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clearFrom()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.downLoad.exportExcel('tableId')
      }
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1),
      expression: "loading1"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "summary-method": _vm.getSummaries,
      "show-summary": "",
      "id": "tableId"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "width": "105",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "width": "110",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "230",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "warehouseName",
      "width": "110",
      "label": "所在仓库"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "warehouseType",
      "label": "仓库类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("sysCodeFileter")(scope.row.warehouseType, 'warehouse_type')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "inventoryATotal",
      "label": "库存总量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "broughtTotal",
      "label": "已领数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "UsefulNumber",
      "label": "可用数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "freezeTotal",
      "label": "冻结数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sumPrice",
      "label": "库存价值"
    }
  }), _vm._v(" "), (_vm.basicsAuth.all_serial_number) ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showSerialNumber(scope.row.materialCoding, null, null, 0, scope.row.warehouseType)
            }
          }
        }, [_vm._v("查看")])]
      }
    }], null, false, 2458301587)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100, 500, 1000],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-content-self",
    attrs: {
      "title": "序列号类型",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-row', {
    staticClass: "table-filter-content"
  }, [_c('el-button', {
    class: {
      active: _vm.shift == 0
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(0)
      }
    }
  }, [_vm._v("全部序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 1
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(1)
      }
    }
  }, [_vm._v("可用序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 2
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(2)
      }
    }
  }, [_vm._v("已领序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 3
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(3)
      }
    }
  }, [_vm._v("冻结序列号")])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "dialog-code-content",
    attrs: {
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading"
    }
  }, _vm._l((_vm.codeList), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('p', [_vm._v(_vm._s(item.code))])])
  }), 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.numberPages.page,
      "page-sizes": [10, 20, 50 ],
      "page-size": _vm.numberPages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.numberPages.total
    },
    on: {
      "size-change": _vm.handleNumberSizeChange,
      "current-change": _vm.handleNumberCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-2e850e48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/workOrder/stockQueryManage.vue
// module id = 1632
// module chunks = 0